import { createContext, useState } from "react";

export const LanguageContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [languages, setLanguages] = useState([]);

    // Make the context object:
    const languageContext = {
        languages,
        setLanguages,
    };

    // pass the value in provider and return
    return <LanguageContext.Provider value={languageContext}>{children}</LanguageContext.Provider>;
};

export const { Consumer } = LanguageContext;
